export const limitCallback = (handler, ms = 100) => {
    let blockingTimeout = false

    return (...args) => {
        if (!blockingTimeout)
            handler(args)
        else
            clearTimeout(blockingTimeout);

        blockingTimeout = setTimeout(() => {
            blockingTimeout = false;
        }, ms)
    }
}

export const pipe = (...fns) => (x) => fns.reduce((acc, fn) => fn(acc), x)